import FieldStrategy from '../FieldStrategy';
import { generateFieldName } from '@/views/fusion/investment/intelligence-create/tools';
import {
  CAMPAIGN_MODULE_KEY,
  CREATIVE_MODULE_KEY,
  CREATIVE_CONTENT_FORM_KEY,
  CREATIVE_COMPONENTS_FORM_KEY,
  TARGETING_MODULE_KEY,
  MATERIAL_MODULE_KEY,
  TITLE_MODULE_KEY,
  SITE_MODULE_KEY,
  CAMPAIGN_BUDGET_AND_BID_FORM_KEY,
} from '@/views/fusion/investment/intelligence-create/strategy/constants';
import { generateDynamicFormModel, collectParentAndSelfLabels } from '@/views/fusion/investment/intelligence-create/tools/form';
import { clone, deepMerge } from '@/utils';
import { isArray, isString } from '@/utils/is';
import { checkboxFilterNone, transformSelectedTimeToTimeSeries } from '@/tools/form';
import { OPTIONS_TYPE, CHANNEL_INTERFACE_TYPE } from '@/enums';
import calculator from '@/utils/calculator';

/**
 * 根据行业id获取行业标签
 * @param {number} id 行业id
 * @returns {string[]} 行业标签
 */
export const getIndustryLabelsById = (id) => {
  const map_ids = {
    101000010001: ['消除', 'IO', '其他'],
    101000010002: ['解谜', '益智', '其他'],
    101000010003: ['其他'],
    101000020001: ['三国杀', '斗地主', '血流成河', '谁是卧底', '其他桌游和棋牌游戏', '血战到底', '麻将', '军棋', '纸牌', '象棋', '五子棋', '围棋', '其他'],
    101000020002: ['其他捕鱼游戏', '捕鱼', '其他'],
    101000020003: ['策略', '卡牌', '修仙', '宠物', '多人在线', '宫廷', '三国志', '中国风', '传奇', '仙侠', '西方魔幻', '魔幻', '武侠', '生存', '其他角色扮演游戏', '放置挂机', '二次元', '回合制', '冒险', '动作', '其他'],
    101000020004: ['足球', '运动', '篮球', '赛车', '其他体育竞技游戏', '竞速', '其他'],
    101000020005: ['ACG', '其他MOBA题材', 'PVP', '竞技', '仙侠', '魔幻', '都市', '实时对战', '二次元', '漫威', '三国', '战棋', '其他'],
    101000020006: ['格斗', '跑酷', '射击', '飞行射击', '其他'],
    101000020010: ['像素风', '捏脸', '科幻', '抽卡', '西游', '恋爱', '现代战略', '盗墓', '沙盒', '塔防', '商战', '布阵', '三国', '治愈', '古代谋略', '其他经营策略游戏', '女性向', '宫廷', '建造', '传奇', '仙侠', '中国风', '换装', '剧情', '魔幻', '都市', '经营', '二次元', '战争', '养成', '其他'],
  };
  return map_ids[id] || [];
};

const icon = {
  label: '图标',
  type: 'image',
  value: '',
  isPreview: false,
  limit: 1,
  is_open: false,
  element_type: null,
  temp_material: null,
  material_restriction: [],
  rules: [],
};

const description = {
  label: '文案',
  type: 'input',
  value: '',
  rules: [],
  word_list: ['日期', '地点', '性别'],
  props: {
    placeholder: '请输入文案',
    maxlength: 24,
    showWordLimit: true,
  },
  isPreview: false,
};

const brand_name = {
  label: '品牌名称',
  type: 'input',
  value: '',
  rules: [],
  props: {
    placeholder: '请输入品牌名称',
    maxlength: 7,
    showWordLimit: true,
  },
};

const ad_button_text = {
  label: '按钮文案',
  type: 'select',
  options: [
    { label: '预约', value: 35 },
    { label: '点击预约', value: 36 },
    { label: '立刻预约', value: 37 },
    { label: '预约游戏', value: 38 },
    { label: '预约福利', value: 39 },
    { label: '预约豪礼', value: 40 },
    { label: '预约领奖', value: 41 },
    { label: '点击赢礼', value: 42 },
  ],
  value: 37,
  rules: { required: true, message: '请选择按钮文案', trigger: ['change'] },
};

const industry_id = {
  label: '行业分类',
  type: 'cascader',
  value: '',
  options: [
    {
      value: 1010,
      label: '游戏',
      children: [
        {
          value: 10100001,
          label: '休闲游戏',
          children: [
            {
              value: 101000010001,
              label: '消除',
            },
            {
              value: 101000010002,
              label: '解谜',
            },
            {
              value: 101000010003,
              label: '其他休闲游戏',
            },
          ],
        },

        {
          value: 10100002,
          label: '网络游戏',
          children: [
            {
              value: 101000020001,
              label: '棋牌桌游',
            },
            {
              value: 101000020002,
              label: '捕鱼游戏',
            },
            {
              value: 101000020003,
              label: '角色扮演',
            },
            {
              value: 101000020004,
              label: '体育竞技',
            },
            {
              value: 101000020005,
              label: 'MOBA',
            },
            {
              value: 101000020006,
              label: '动作射击',
            },
            {
              value: 101000020010,
              label: '经营策略',
            },
          ],
        },
      ],
    },
  ],
  rules: [],
  props: {
    placeholder: '请选择行业分类',
    props: {
      emitPath: false,
    },
  },
};

const industry_labels = {
  label: '行业标签',
  type: 'select',
  value: [],
  options: [],
  rules: [],
  props: {
    placeholder: '请选择行业标签',
    multiple: true,
    collapseTags: true,
    multipleLimit: 3,
    filterable: true,
  },
};

// 【内容配置】表单配置
const content_form_config = {
  icon,
  description,
  brand_name,
};

// 【创意组件】表单配置
const creative_components_config = {
  ad_button_text,
  industry_id,
  industry_labels,
};

/**
 * 华为策略类
 */
export default class HuaWeiFieldStrategy extends FieldStrategy {
  /**
   * 获取差异化模块字段
   * @returns {Object}
   */
  getDifferentiatedFields() {
    return {
      campaign_config: {
        config: {
          site_form: {
            config: {
              site_set_type: {
                props: {
                  disabled: true,
                },
                value: 2,
              },
              site_sets: {
                rules: {
                  required: true,
                  message: '请选择广告版位',
                  trigger: ['change'],
                },
                hidden: false,
                props: {
                  max: 1,
                },
                value: ['1198502153635846016'], // 默认智能优选
                labelTips: '更改广告版位需重新填写创意中的「内容配置」和「创意组件」',
              },
            },
          },
          delivery_form: {
            config: {
              delivery_platform_type: {
                value: 'ANDROID_APP',
              },
              delivery_content_id: {
                type: '',
                is_single_advertiser_assign: true,
                is_open: false,
                value: {
                  type_selection: [
                    { label: 'Android应用', value: 'ANDROID_APP' },
                  ],
                  result_map: {},
                },
                isPreview: false,
                rules: {
                  required: true,
                  trigger: ['change'],
                  validator: (_, value, callback) => {
                    if (Object.keys(value.result_map).length) {
                      callback();
                    } else {
                      callback(new Error('请选择投放内容'));
                    }
                  },
                },
              },
              objective_type: {
                label: '投放目的',
                type: 'radio-group',
                isButton: true,
                options: [
                  { label: '应用下载', value: 'APP_DOWNLOAD' },
                  { label: '预约下载', value: 'APP_RESERVE_DOWNLOAD' },
                ],
                value: 'APP_DOWNLOAD',
                rules: { required: true, message: '请选择投放目的', trigger: ['change'] },
              },
            },
          },
          budget_and_bid_form: {
            config: {
              conversion_cost: {
                label: '期望转化成本',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 2,
                  min: 0.01,
                  max: 999999999.00,
                },
                formItemTips: {
                  props: {
                    class: 'inline-block',
                    style: {
                      marginLeft: '10px',
                    },
                  },
                  content: '元',
                },
                value: 0.01,
              },
              price_strategy: {
                value: 'OCPC_STRATEGY_STANDARD',
              },
            },
          },
        },
      },
      creative_config: {
        config: {
          content_form: {
            config: {},
          },
          creative_components: {
            config: {},
          },
        },
      },
      targeting_config: {
        config: {
          targeting_form: {
            config: {
              /** 年龄 */
              ages: {
                label: '年龄',
                type: 'checkbox-group',
                value: [OPTIONS_TYPE.UNLIMITED],
                options: [],
                isButton: true,
              },
              /** APP安装 */
              app_install_status: {
                label: 'APP安装',
                type: 'radio-group',
                options: [
                  { label: '未安装', value: 2 },
                  { label: '已安装', value: 1 },
                ],
                value: 2,
                isButton: true,
                props: {
                  disabled: true,
                },
              },
              /** 设备信息 */
              device: {
                value: {},
                children: {
                  /** 设备品牌类型 */
                  device_type: {
                    label: '设备品牌',
                    type: 'radio-group',
                    options: [
                      { label: '不限', value: 'INFINITE' },
                      { label: '自定义', value: 'CUSTOM', disabled: false },
                    ],
                    value: 'INFINITE',
                    isButton: true,
                  },
                  /** 设备品牌 */
                  devices: {
                    label: ' ',
                    type: 'tree-shuttle',
                    options: [],
                    value: [],
                    props: {
                      nodeKey: 'value',
                    },
                    name: '设备品牌',
                    hidden: true,
                    rules: {
                      required: true,
                      trigger: ['blur'],
                      validator: (rule, value, callback) => {
                        if (value.length) {
                          callback();
                        } else {
                          callback(new Error('请选择设备品牌'));
                        }
                      },
                    },
                  },
                  /** 设备价格 */
                  device_prices: {
                    label: '设备价格',
                    type: 'checkbox-group',
                    value: [OPTIONS_TYPE.UNLIMITED],
                    options: [],
                    isButton: true,
                  },
                },
              },
              /** 联网方式 */
              network_types: {
                label: '联网方式',
                type: 'checkbox-group',
                value: [OPTIONS_TYPE.UNLIMITED],
                options: [],
                isButton: true,
              },
              /** 智能扩量 */
              ai_target: {
                value: {},
                children: {
                  /** 智能扩量类型 */
                  ai_target_type: {
                    label: '智能扩量',
                    type: 'radio-group',
                    options: [
                      { label: '不开启', value: 'AI_TARGET_DISABLE' },
                      { label: '开启', value: 'AI_TARGET_ENABLE' },
                    ],
                    value: 'AI_TARGET_DISABLE',
                    isButton: true,
                  },
                  /** 智能扩量 */
                  ai_targets: {
                    label: ' ',
                    type: 'checkbox-group',
                    value: [],
                    options: [
                      { label: '地域', value: 'LOCATION', disabled: true },
                      { label: '性别', value: 'GENDER', disabled: true },
                      { label: '年龄', value: 'AGE', disabled: true },
                      { label: '设备', value: 'DEVICE', disabled: true },
                      { label: '联网方式', value: 'NETWORK_TYPE', disabled: true },
                      { label: 'APP安装', value: 'APP_INSTALL', disabled: false },
                    ],
                    isButton: true,
                    hidden: true,
                    rules: {
                      required: true,
                      message: '请选择智能扩量',
                      trigger: ['change'],
                    },
                  },
                },
              },
            },
          },
        },
      },
      material_config: {
        config: {
          material_form: {
            config: {
              material: {
                props: {
                  type: 'image',
                  tempMaterial: null,
                },
                materialRestrictionMap: {
                  image: [
                    { width: 1080, height: 607 },
                    { width: 1080, height: 1920 },
                    { width: 1080, height: 1620 },
                    { width: 225, height: 150 },
                    { width: 900, height: 900 },
                    { width: 1080, height: 170 },
                    { width: 720, height: 960 },
                  ],
                  video: [
                    { width: 640, height: 360 },
                    { width: 1280, height: 720 },
                    { width: 720, height: 1280 },
                    { width: 640, height: 640 },
                  ],
                },
              },
            },
          },
        },
      },
    };
  }

  /**
   * 添加事件
   * @param {Object} config 模块配置
   */
  addEvent(config) {
    super.addEvent(config);
    const {
      campaign_config: {
        config: {
          budget_and_bid_form,
          site_form,
          delivery_form,
        },
      },
      creative_config: {
        config: {
          creative_components,
        },
      },
      targeting_config: {
        config: {
          targeting_form,
        },
      },
    } = config;
    const { delivery_platform_type, delivery_content_id, objective_type } = delivery_form.config;
    const {
      price_type,
      price_strategy,
      convert_id,
      fusion__optimize_goal,
      deep_convert_type,
      conversion_cost,
      deep_convert_price,
    } = budget_and_bid_form.config;
    const { site_sets } = site_form.config;

    const { industry_id, industry_labels } = creative_components.config;
    const {
      geo_location: {
        children: {
          geo_type,
          location_type,
          residence_geo_locations,
          current_geo_locations,
        },
      },
      gender,
      ages,
      ai_target: {
        children: {
          ai_target_type,
          ai_targets,
        },
      },
      device: {
        children: {
          device_type,
          devices,
          device_prices,
        },
      },
      network_types,
    } = targeting_form.config;

    // 行业分类
    if (industry_id) {
      industry_id.on = {
        change() {
          const labels = getIndustryLabelsById(industry_id.value);
          industry_labels.options = labels.map(label => {
            return {
              label,
              value: label,
            };
          });
          if (isArray(industry_labels.value)) {
            industry_labels.value = industry_labels.value.filter(v => labels.includes(v));
          } else if (isString(industry_labels.value)) {
            industry_labels.value = labels.includes(industry_labels.value) ? industry_labels.value : '';
          }
        },
      };
    }

    // 投放平台
    delivery_platform_type.on = {
      change: () => {},
    };

    // 投放内容
    delivery_content_id.on = {
      change: () => {},
    };

    // 投放目的
    objective_type.on = {
      change() {
        // 投放目的 - 预约下载
        const is_reserve = objective_type.value === 'APP_RESERVE_DOWNLOAD';
        // 广告版位 - HarmonyOS服务
        const is_harmony_os = site_sets.value.includes('1278796325500130176');

        const cpd_opt = price_type.options.find(opt => opt.value === 'PRICING_CPD');
        const ocpc_opt = price_type.options.find(opt => opt.value === 'PRICING_OCPC');
        cpd_opt.disabled = (!is_reserve && !is_harmony_os) || is_reserve;
        ocpc_opt.disabled = is_reserve;

        const is_disabled = price_type.options.some(opt => opt.value === price_type.value && opt.disabled);
        if (is_disabled) {
          price_type.value = 'PRICING_CPC';
          price_type?.on?.change?.();
        }
      },
    };

    // 出价方式
    price_type.on = {
      change() {
        const val = price_type.value;
        const is_ocpc = val === 'PRICING_OCPC';
        const fields = [
          price_strategy,
          convert_id,
          fusion__optimize_goal,
          deep_convert_type,
          conversion_cost,
        ];
        fields.forEach(field => {
          field.hidden = !is_ocpc;
        });

        /**
         * 深度优化出价
         * 满足以下条件才会显示
         * - 出价方式：ocpc
         * - 深度优化目标有数据项
         * - 深度优化目标类型存在值且不为0
         */
        deep_convert_price.hidden = !(is_ocpc && deep_convert_type.options.length && deep_convert_type.value && deep_convert_type.value !== 0);

        // 优化目标
        fusion__optimize_goal.hidden = !(is_ocpc && convert_id.value);

        // 深度优化目标
        deep_convert_type.hidden = !(is_ocpc && convert_id.value && deep_convert_type.options.length);
      },
    };

    /** 深度优化目标 */
    deep_convert_type.on = {
      change() {
        const val = price_type.value;
        const is_ocpc = val === 'PRICING_OCPC';
        /**
         * 深度优化出价
         * 满足以下条件才会显示
         * - 出价方式：ocpc
         * - 深度优化目标有数据项
         * - 深度优化目标类型存在值且不为0
         */
        deep_convert_price.hidden = !(is_ocpc && deep_convert_type.options.length && deep_convert_type.value && deep_convert_type.value !== 0);
      },
    };

    // 地域选项
    geo_type.on = {
      change() {
        const is_location = geo_type.value === 'LOCATION';
        const is_residence = location_type.value === 'RESIDENCE';
        const is_current = location_type.value === 'CURRENT';
        location_type.hidden = !is_location;
        residence_geo_locations.hidden = !(is_location && is_residence);
        current_geo_locations.hidden = !(is_location && is_current);

        /**
         * 智能扩量 - 【地域】选项的禁选逻辑，因华为媒体方接口有bug，需待后续修复后，再还原此逻辑，暂留
         * // 智能扩量
         * ai_targets.options.forEach(opt => (opt.value === 'LOCATION' && (opt.disabled = !is_location)));
         * !is_location && (ai_targets.value = ai_targets.value.filter(val => val !== 'LOCATION'));
         */
      },
    };

    // 性别
    gender.on = {
      change() {
        const is_unlimited = gender.value === OPTIONS_TYPE.UNLIMITED;
        // 智能扩量
        ai_targets.options.forEach(opt => (opt.value === 'GENDER' && (opt.disabled = is_unlimited)));
        is_unlimited && (ai_targets.value = ai_targets.value.filter(val => val !== 'GENDER'));
      },
    };

    // 年龄
    ages.on = {
      change() {
        ages.value = checkboxFilterNone(ages.value, OPTIONS_TYPE.UNLIMITED);
        const is_unlimited = ages.value.includes(OPTIONS_TYPE.UNLIMITED);
        // 智能扩量
        ai_targets.options.forEach(opt => (opt.value === 'AGE' && (opt.disabled = is_unlimited)));
        is_unlimited && (ai_targets.value = ai_targets.value.filter(val => val !== 'AGE'));
      },
    };

    // 设备类型
    device_type.on = {
      change() {
        const is_custom = device_type.value === 'CUSTOM';
        devices.hidden = !is_custom;
        device_prices.options.forEach(opt => (opt.value !== OPTIONS_TYPE.UNLIMITED) && (opt.disabled = is_custom));
        // 智能扩量
        ai_targets.options.forEach(opt => (opt.value === 'DEVICE' && (opt.disabled = !is_custom)));
        !is_custom && (ai_targets.value = ai_targets.value.filter(val => val !== 'DEVICE'));
      },
    };

    // 设备价格
    device_prices.on = {
      change() {
        device_prices.value = checkboxFilterNone(device_prices.value, OPTIONS_TYPE.UNLIMITED);
        const is_unlimited = device_prices.value.includes(OPTIONS_TYPE.UNLIMITED);
        device_type.options.forEach(opt => (opt.value === 'CUSTOM') && (opt.disabled = !is_unlimited));
        // 智能扩量
        ai_targets.options.forEach(opt => (opt.value === 'DEVICE' && (opt.disabled = is_unlimited)));
        is_unlimited && (ai_targets.value = ai_targets.value.filter(val => val !== 'DEVICE'));
      },
    };

    // 联网方式
    network_types.on = {
      change() {
        network_types.value = checkboxFilterNone(network_types.value, OPTIONS_TYPE.UNLIMITED);
        const is_unlimited = network_types.value.includes(OPTIONS_TYPE.UNLIMITED);
        // 智能扩量
        ai_targets.options.forEach(opt => (opt.value === 'NETWORK_TYPE' && (opt.disabled = is_unlimited)));
        is_unlimited && (ai_targets.value = ai_targets.value.filter(val => val !== 'NETWORK_TYPE'));
      },
    };

    // 智能扩量类型
    ai_target_type.on = {
      change() {
        const is_enable = ai_target_type.value === 'AI_TARGET_ENABLE';
        ai_targets.hidden = !is_enable;
      },
    };

    // 广告版位
    site_sets.on = {
      change() {
        // 投放目的 - 预约下载
        const is_reserve = objective_type.value === 'APP_RESERVE_DOWNLOAD';
        // 广告版位 - HarmonyOS服务
        const is_harmony_os = site_sets.value.includes('1278796325500130176');

        const cpd_opt = price_type.options.find(opt => opt.value === 'PRICING_CPD');
        const cpm_opt = price_type.options.find(opt => opt.value === 'PRICING_CPM');
        cpd_opt.disabled = (!is_reserve && !is_harmony_os) || is_reserve;
        cpm_opt.disabled = is_harmony_os;

        const is_disabled = price_type.options.some(opt => opt.value === price_type.value && opt.disabled);
        if (is_disabled) {
          price_type.value = 'PRICING_CPC';
          price_type?.on?.change?.();
        }
      },
    };
  }

  /**
   * 获取覆盖字符对象
   * @returns {Object}
   */
  getDifferentiatedOverrides() {
    // 文案
    const description = generateFieldName([CREATIVE_MODULE_KEY, CREATIVE_CONTENT_FORM_KEY, 'description']);

    // 图标
    const icon = generateFieldName([CREATIVE_MODULE_KEY, CREATIVE_CONTENT_FORM_KEY, 'icon']);

    // 创意行业
    const industry_id = generateFieldName([CREATIVE_MODULE_KEY, CREATIVE_COMPONENTS_FORM_KEY, 'industry_id']);

    /** 转化事件 */
    const convert_id = generateFieldName([CAMPAIGN_MODULE_KEY, CAMPAIGN_BUDGET_AND_BID_FORM_KEY, 'convert_id']);

    return {
      [description]({ field_config }) {
        field_config.isPreview = true;
      },

      [icon]({ field_config }) {
        field_config.isPreview = true;
        field_config.type = '';
      },

      [industry_id]({ field_config, key, raw_config }) {
        const result = collectParentAndSelfLabels(raw_config[key].options, { value: raw_config[key].value });
        field_config.value = result ? result.join('/') : '-';
      },

      [convert_id]: ({ field_config, raw_config }) => {
        field_config.type = 'label';
        const is_ocpc = raw_config.price_type.value === 'PRICING_OCPC';
        field_config.hidden = !(field_config.value && is_ocpc);
        field_config.value = field_config.value ? JSON.parse(field_config.value).name : '-';
        field_config.isPreview = true;
      },

    };
  }

  /**
   * 设置配置模块的数据源
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   */
  async setFieldDataSources(config, controller) {
    try {
      await super.setFieldDataSources(config, controller);
      const {
        campaign_config: {
          config: {
            budget_and_bid_form,
          },
        },
      } = config;
      /** 出价方式 - 默认禁选CPD */
      const { price_type } = budget_and_bid_form.config;
      price_type.options.forEach(opt => {
        Object.assign(opt, { disabled: opt.value === 'PRICING_CPD' });
      });
    } catch (error) {
      console.error(error);
      throw new Error('HuaWeiFieldStrategy: setFieldDataSources fail');
    }
  }

  /**
   * 设置定向模块的数据源
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   */
  async setTargetingDataSources(config, controller) {
    await super.setTargetingDataSources(config, controller);
    const {
      ages,
      device: {
        children: {
          devices,
          device_prices,
        },
      },
      network_types,
    } = config.targeting_config.config.targeting_form.config;

    // 定向字典
    const targeting_dictionary = await controller.getTargetingDictionary(['age', 'device', 'device_price', 'network_type']);
    const unlimited_selection = {
      label: '不限',
      value: OPTIONS_TYPE.UNLIMITED,
    };

    // 年龄
    ages.options = [unlimited_selection, ...(targeting_dictionary?.age || [])];
    // 设备品牌
    devices.options = targeting_dictionary?.device || [];
    // 设备价格
    device_prices.options = [unlimited_selection, ...((targeting_dictionary?.device_price || []).map(item => Object.assign(item, { disabled: false })))];
    // 联网方式
    network_types.options = [unlimited_selection, ...(targeting_dictionary?.network_type || [])];
  }

  /**
   * 模块字段排序
   * @param {Object} fields
   * @returns {Object}
   */
  async setFieldsSort(fields) {
    const { campaign_config } = fields;
    const {
      daily_budget_type,
      daily_budget,
      price_type,
      price_strategy,
      convert_id,
      fusion__optimize_goal,
      deep_convert_type,
      price,
      conversion_cost,
      deep_convert_price,
      ...rest
    } = campaign_config.config.budget_and_bid_form.config;
    campaign_config.config.budget_and_bid_form.config = {
      daily_budget_type,
      daily_budget,
      price_type,
      price_strategy,
      convert_id,
      fusion__optimize_goal,
      deep_convert_type,
      price,
      conversion_cost,
      deep_convert_price,
      ...rest,
    };
    return Promise.resolve(fields);
  }

  /**
   * 设置动态渲染组件
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   * @param {Object} payload 传递的数据，不限制键名和值
   */
  async setDynamicComponent(config, controller, payload) {
    if (config && controller && payload) {
      const { raw_ref_form_model, raw_form_model, form_assign_data, extra_base_params = {}} = payload;
      const is_site_sets_changed = JSON.stringify(raw_ref_form_model['campaign_config.site_form']?.site_sets) !== JSON.stringify(raw_form_model['campaign_config.site_form']?.site_sets);
      const is_objective_type_changed = JSON.stringify(raw_ref_form_model['campaign_config.delivery_form']?.objective_type) !== JSON.stringify(raw_form_model['campaign_config.delivery_form']?.objective_type);
      if (is_site_sets_changed || is_objective_type_changed) {
        delete form_assign_data.creative_config;
        const params = {
          ...extra_base_params,
          huawei_params: {
            filtering: {
              objective_type: raw_ref_form_model['campaign_config.delivery_form']?.objective_type,
            },
          },
        };
        const { creative_config: { config: { content_form, creative_components }}} = config;
        const { list, names } = await controller.getDynamicComponent(params);
        // 重新初始化【内容配置】表单配置
        content_form.config = Object.assign(content_form.config, clone(content_form_config));

        // 重新初始化【创意组件】表单配置
        creative_components.config = clone(creative_components_config);
        const dynamic_component_keys = ['icon', 'description', 'brand_name', 'ad_button_text', 'industry_id', 'industry_labels'];

        [content_form, creative_components].forEach(target => {
          Object.keys(target.config).forEach(key => {
            if (!names.includes(key) && dynamic_component_keys.includes(key)) {
              delete target.config[key];
            }
          });
          const ret = list.filter(item => target.config[item.name]);
          list.forEach((item) => Object.assign(item, { element_type: target.config[item.name]?.type }));
          target.config = deepMerge([target.config, generateDynamicFormModel(ret)]);
        });
      }
    }
  }

  /**
   * 转换差异化广告预览参数
   * @param {Object} data 数据
   * @param {Object} data.form_assign_data 提交参数
   * @returns {Object}
   */
  transformDifferentiatedCampaignPreviewPayload({ form_assign_data }) {
    const {
      campaign_config: {
        delivery_form: {
          objective_type,
        },
        schedule_form: {
          time_period_type,
          schedule_time,
          time_period,
        },
        budget_and_bid_form: {
          price_type,
          conversion_cost,
        },
      },
    } = form_assign_data;
    return {
      /** 投放目的 */
      objective_type,
      /** 投放时间类型 */
      time_period_type,
      /** 投放时间 - 指定时间 */
      ...(time_period_type === 'TIME_PERIOD_DAY_SPECIFIC' && { time_period: transformSelectedTimeToTimeSeries(schedule_time.start, schedule_time.end) }),
      /** 投放时间 - 指定多个时间 */
      ...(time_period_type === 'TIME_PERIOD_HOUR_SPECIFIC' && { time_period: time_period.schedule_time_content }),
      /** oCPC */
      ...(price_type === 'PRICING_OCPC' && {
        /** 期望转化成本 */
        conversion_cost: calculator.times(conversion_cost, 100),
      }),
    };
  }

  /**
   * 转换差异化创意预览参数
   * @param {Object} data 数据
   * @param {Object} data.form_assign_data 提交参数
   * @returns {Object}
   */
  transformDifferentiatedCreativePreviewPayload({ form_assign_data }) {
    const {
      creative_config: {
        content_form: {
          icon,
          description,
          brand_name,
        } = {},
        creative_components: {
          ad_button_text,
          industry_id,
          industry_labels,
        } = {},
      },
    } = form_assign_data;
    return {
      /** 图标 */
      ...(icon && { icon }),
      /** 文案 */
      ...(description && { description }),
      /** 品牌名称 */
      ...(brand_name && { brand_name }),
      /** 按钮文案 */
      ...(ad_button_text && { ad_button_text }),
      /** 创意行业 */
      ...(industry_id && { industry_id }),
      /** 行业分类 */
      ...(industry_labels?.length && { industry_labels }),
    };
  }

  /**
   * 获取创建定向包差异化接口参数
   * @param {Object} target_data 定向数据
   * @param {Object} target_form_config 定向表单配置
   * @returns {Object}
   */
  getDifferentiatedCreateTargetParams(target_data, target_form_config) {
    const {
      ages,
      app_install_status,
      device: {
        device_type,
        devices,
        device_prices,
      },
      network_types,
      ai_target,
    } = target_data;

    const {
      device: {
        children: {
          devices: devices_config,
        },
      },
    } = target_form_config;

    const target_params = {
      [`${CHANNEL_INTERFACE_TYPE.HUAWEI}_params`]: {
        // 年龄
        ...(!ages.includes(OPTIONS_TYPE.UNLIMITED) && { ages }),
        // APP安装
        app_install_status,
        // 设备信息
        device: {
          device_type,
          // 设备品牌 - 选中一级数据时，参数需传二级数据
          ...(devices?.length && (() => {
            let result = devices;
            devices_config.options.forEach(({ value, children }) => {
              if (result.includes(value)) {
                result = result.filter(val => val !== value);
                result.push(...children.map(({ value }) => value));
              }
            });
            return { devices: result };
          })()),
          ...(!device_prices.includes(OPTIONS_TYPE.UNLIMITED) && { device_prices }),
        },
        // 联网方式
        ...(!network_types.includes(OPTIONS_TYPE.UNLIMITED) && { network_types }),
        // 智能扩量
        ai_target,
      },
    };

    return target_params;
  }

  /**
   * 获取定向包差异化详情表单数据
   * @param {Object} target_params 定向详情数据
   * @returns {Object}
   */
  getDifferentiatedTargetDetailFormData(target_params) {
    const {
      [`${CHANNEL_INTERFACE_TYPE.HUAWEI}_params`]: {
        ages,
        app_install_status,
        device,
        network_types,
        ai_target,
      } = {},
    } = target_params;

    const form_data = {
      // 年龄
      ...(ages && { ages }),
      // APP安装
      app_install_status,
      // 设备信息
      device,
      // 联网方式
      ...(network_types && { network_types }),
      // 智能扩量
      ai_target,
    };

    return form_data;
  }

  /**
   * 获取定向数据转预览数据关联表
   * @returns {Object}
   */
  getTargetPreviewAssociatedMap() {
    return {
      device_type: {
        unlimit_key: 'INFINITE',
        associated_keys: ['devices'],
      },
      ai_target_type: {
        unlimit_key: 'AI_TARGET_DISABLE',
        associated_keys: ['ai_targets'],
      },
    };
  }

  /**
   * 是否显示预览按钮
   * @param {Object} form_assign_data 分配数据
   * @param {Object} form_fields 源数据
   * @returns {boolean}
   */
  isShowPreviewBtn(form_assign_data, form_fields) {
    const all_keys = [CAMPAIGN_MODULE_KEY, CREATIVE_MODULE_KEY, TARGETING_MODULE_KEY];
    const is_has_all_kays = all_keys.every(key => !!form_assign_data[key]);
    if (!is_has_all_kays) {
      return false;
    }
    const {
      campaign_config: {
        site_form: {
          site_sets,
        },
        delivery_form: {
          objective_type,
        },
      },
    } = form_assign_data;
    // 广告版位为HarmonyOS服务时，素材和标题为非必填配置
    const is_harmony_os = site_sets.includes('1278796325500130176');
    // 投放目的为预约下载时，落地页为非必填
    const is_reserve_download = objective_type === 'APP_RESERVE_DOWNLOAD';
    if (is_harmony_os || is_reserve_download) {
      const assign_keys = [
        TARGETING_MODULE_KEY,
        ...(is_harmony_os ? [] : [TITLE_MODULE_KEY]),
        ...(is_reserve_download ? [] : [SITE_MODULE_KEY]),
      ];
      const material = form_assign_data[MATERIAL_MODULE_KEY];
      const is_has_material = material?.images?.length > 0 || material?.videos?.length > 0;
      return assign_keys.every(key => form_assign_data[key]?.length > 0) && (!is_harmony_os ? is_has_material : true);
    } else {
      return super.isShowPreviewBtn(form_assign_data, form_fields);
    }
  }

  /**
   * 获取素材属性
   * @param {Object} material_config 素材表单配置
   * @returns {Object}
   */
  getMaterialProps(material_config) {
    const { value, materialRestrictionMap } = material_config?.config?.material_form?.config?.material;
    return { materialRestriction: materialRestrictionMap[value.tab] };
  }

  /**
   * 获取差异化模板配置表
   * @returns {Object}
   */
  getDifferentiatedTemplateMap() {
    return {
      campaign_config: {
        delivery_form: ['objective_type'],
        budget_and_bid_form: ['conversion_cost'],
      },
      creative_config: {
        content_form: ['icon', 'description', 'brand_name'],
      },
    };
  }

  /**
   * 是否重新渲染动态创意
   * @param {Object} old_campaign_config 旧广告配置
   * @param {Object} new_campaign_config 新广告配置
   * @returns {Boolean}
   */
  isReRenderCreative(old_campaign_config, new_campaign_config) {
    const {
      delivery_form: {
        config: {
          objective_type: old_objective_type,
        },
      },
      site_form: {
        config: {
          site_sets: old_site_sets,
        },
      },
    } = old_campaign_config.config;

    const {
      delivery_form: {
        config: {
          objective_type: new_objective_type,
        },
      },
      site_form: {
        config: {
          site_sets: new_site_sets,
        },
      },
    } = new_campaign_config.config;

    const is_objective_type_changed = JSON.stringify(old_objective_type.value) !== JSON.stringify(new_objective_type.value);
    const is_site_sets_changed = JSON.stringify(old_site_sets.value) !== JSON.stringify(new_site_sets.value);

    return is_objective_type_changed || is_site_sets_changed;
  }
}
